<template>
  <div class="foot wow fadeIn" data-wow-duration="3s">
    <div class="top">
      <div class="box">
        <img src="../../public/image/footlogo.png" alt />
        <div class="classlist">
          <ul>
            <li
              v-for="(item, index) in aboutlist"
              :key="index"
              @click="gotoPage(0, index)"
            >
              {{ item }}
            </li>
          </ul>
          <ul>
            <li @click="gotoPage(1, 0)">{{ $t("list")[2] }}</li>
            <li
              v-for="(item, index) in prolist"
              :key="index"
              @click="gotoPage(1, item.id)"
            >
              {{ item.title }}
            </li>
          </ul>
          <ul>
            <li @click="gotoPage(2, 0)">{{ $t("list")[3] }}</li>
            <li
              v-for="(item, index) in newslist"
              :key="index"
              @click="gotoPage(2, item.id)"
            >
              {{ item.classname }}
            </li>
          </ul>
          <ul>
            <li
              v-for="(item, index) in selalist"
              :key="index"
              @click="gotoPage(3, index)"
            >
              {{ item }}
            </li>
          </ul>
          <ul>
            <li
              v-for="(item, index) in contactlist"
              :key="index"
              @click="gotoPage(4, index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="right">
          <img style="opacity:0;" src="../../public/image/qrcode.png" alt />
          <p style="opacity:0;">{{ $t("foot").text3 }}</p>
          <div class="totop" @click="gotoTop">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="b_box">
        <div class="b_wrap">
          <p>{{ $t("foot").text1 }}</p>
          <div class="b_line">
            <p>{{ $t("foot").text4 }}</p>
            <p>
              <a href>{{ $t("foot").text5 }}</a> |
              <a href>{{ $t("foot").text6 }}</a>
            </p>
            <p>
              <a href="https://www.seniorweb.cn/" target="_blank">{{
                $t("foot").text2
              }}</a>
            </p>
          </div>
        </div>
        <div class="icon">
          <div class="iconitem">
            <i class="iconfont icon-gongzhonghao"></i>
          </div>
          <div class="iconitem">
            <i class="iconfont icon-QQ"></i>
          </div>
          <div class="iconitem">
            <i class="iconfont icon-weibo"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFooter } from "../util/lang";
export default {
  data() {
    return {
      top: true,
      aboutlist: ["关于宇晟", "公司介绍", "企业理念"],
      prolist: [
        "产品中心",
        "乙酰丙酮铝",
        "乙酰丙酮铝",
        "乙酰丙酮铝",
        "乙酰丙酮铝",
      ],
      newslist: ["新闻中心", "企业资讯", "展会信息"],
      selalist: ["销售网络", "销售分布", "客户展示", "销售展望"],
      contactlist: ["联系我们", "在线留言", "联系方式"],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getfoot();
    });
  },
  methods: {
    gotoTop() {
      this.$emit("transferTop", this.top);
    },
    getfoot() {
      const url = `${getFooter()}`;
      this.aboutlist = this.$t("foot").list.aboutlist;
      this.selalist = this.$t("foot").list.selalist;
      this.contactlist = this.$t("foot").list.contactlist;
      this.$axios.post(url).then((res) => {
        this.prolist = res.data.products;
        this.newslist = res.data.news_type;
      });
    },
    gotoPage(i, index) {
      if (i == 0 && index == 0) {
        window.open(`./about.html`, "_self");
      } else if (i == 0 && index != 0) {
        window.open(`./about.html?id=${index - 1}`, "_self");
      } else if (i == 1 && index == 0) {
        window.open(`./produce.html`, "_self");
      } else if (i == 1 && index != 0) {
        window.open(`./proinfo.html?id=${index}`, "_self");
      } else if (i == 2 && index == 0) {
        window.open(`./news.html`, "_self");
      } else if (i == 2 && index != 0) {
        window.open(`./news.html?id=${index}`, "_self");
      } else if (i == 3) {
        window.open(`./sale.html`, "_self");
      } else {
        window.open(`./contact.html`, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lang-en .b_wrap {
  flex-direction: column;
  .b_line {
    padding-left: 0 !important;
  }
  p {
    padding: 0 !important;
  }
}
.foot {
  background-color: #272727;
  width: 100%;
  .top {
    padding-top: 80px;
    width: 100%;
    border-bottom: 1px solid #363333;
    .box {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      // justify-content: space-around;
      img {
        display: block;
        align-self: flex-start;
        width: 138px;
        object-fit: contain;
      }
      .classlist {
        display: flex;
        flex: 1;
        justify-content: space-between;
        width: 60%;
        padding-bottom: 200px;
        padding-left: 100px;
        ul {
          position: relative;
          // padding: 0 80px 0 20px;
          padding-left: 20px;
          margin-right: 30px;
          &::before {
            display: inline-block;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 1px;
            background-color: #373737;
            // opacity: 0.5;
          }
          li {
            list-style: none;
            color: white;
            opacity: 0.5;
            font-size: 12px;
            font-family: "SOURCEHANSANSCN-EXTRALIGHT";
            margin-bottom: 15px;
            cursor: pointer;
            transition: all 600ms;
            &:hover {
              opacity: 1;
            }
          }
          li:nth-child(1) {
            opacity: 1;
            font-size: 14px;
            margin-bottom: 20px;
          }
        }
      }
      .right {
        margin-left: auto;
        width: 138px;
        p {
          text-align: center;
          color: white;
          font-size: 12px;
          font-family: "SOURCEHANSANSCN-EXTRALIGHT";
          line-height: 30px;
        }
        .totop {
          width: 48px;
          height: 48px;
          border: 1px solid #999999;
          position: relative;
          margin-top: 100px;
          margin-left: auto;
          cursor: pointer;
          transition: all 300ms;
          &:hover {
            border-color: white;
            i {
              color: white;
            }
          }
          i {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #999999;
            transition: all 300ms;
          }
        }
      }
    }
  }
  .bottom {
    width: 100%;
    .b_wrap {
      display: flex;
    }
    .b_line {
      display: flex;
      padding-left: 10px;
    }
    .b_box {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      p {
        color: white;
        opacity: 0.5;
        font-family: "SOURCEHANSANSCN-EXTRALIGHT";
        font-weight: 200;
        font-size: 14px;
        padding: 20px 0;
        line-height: 30px;
        a {
          color: white;
          font-family: "SOURCEHANSANSCN-EXTRALIGHT";
        }
      }
      p:not(:nth-child(1)) {
        margin-left: 10px;
      }
      .icon {
        margin-left: auto;
        display: flex;
        align-items: center;
        .iconitem {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #5f5f5f;
          position: relative;
          cursor: pointer;
          transition: all 300ms;
          margin-left: 20px;
          &:hover {
            background-color: #008cd6;
            i {
              color: white;
            }
          }
          i {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 20px;
            color: #c4c4c4;
            cursor: pointer;
            transition: all 300ms;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .foot {
    .top {
      .box {
        width: 1200px;
      }
    }
    .bottom {
      .b_box {
        width: 1200px;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .lang-en {
    
    .b_line {
      flex-direction: column;
    }
    .bottom {
      text-align: center;
      padding: 0 15px !important;
      p {
        margin-left: 0 !important;
      }
    }
  }
  .foot {
    .top {
      padding-top: 40px;
      .box {
        width: 100%;
        flex-direction: column;
        align-items: center;
        img {
          align-self: unset;
          margin-bottom: 20px;
        }
        .classlist {
          display: none;
        }
        .right {
          margin-left: unset;
          .totop {
            position: fixed;
            bottom: 160px;
            right: 20px;
          }
        }
      }
    }
    .bottom {
      box-sizing: border-box;
      .b_wrap {
        flex-direction: column;
      }
      .b_box {
        width: 100%;
        flex-direction: column;
        align-items: center;
        p {
          font-size: 12px;
          padding: 5px 0;
          line-height: unset;
        }
        .icon {
          margin-left: unset;
          padding-bottom: 5px;
        }
      }
    }
  }
}
</style>
